module.exports = "<h1 id=\"复选框--m-checkbox\">复选框  m-checkbox</h1>\n";